import { Fancybox } from "@fancyapps/ui";
import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import { Thumbs } from "@fancyapps/ui/dist/carousel/carousel.thumbs.esm.js";
import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
Swiper.use([Navigation, Scrollbar]);

export const initCarousel = () => {
    

    

    //if (carouselContainer) {
    //    const options = {
    //        Dots: false,
    //        infinite: true,

    //        Thumbs: {

    //        },
    //    };

    //    const carousel = new Carousel(carouselContainer);

    //    if (options.Thumbs) {
    //        new Thumbs(carousel, options.Thumbs);
    //    }

    //new Carousel(carouselContainer);
    var fancyboxContainer = document.querySelectorAll('.service-page__machine--gallery');
    if (fancyboxContainer) {
        Fancybox.bind('[data-fancybox="gallery"]', {
            Carousel: {
                Dots: false,
            },
        });
    }
 



}